// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hive_isxbfw9{margin:48px auto 32px;}.hive_isxbfw9 img{min-height:80px;}\n", ""]);
// Exports
module.exports = exports;
